import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-category-list-main',
  templateUrl: './category-list-main.component.html',
  styleUrls: ['./category-list-main.component.css']
})
export class CategoryListMainComponent implements OnInit {
    public itemsListMainCategories: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadMainCategories(): Promise<void> {
        this.itemsListMainCategories = await this.datatask.Post(626);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'categorylinkadd':
                this.stateService?.go('categorylinkadd', { category_keyno_belongto: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadMainCategories();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('categoryListMain', {
//        templateUrl: 'views/components/views/categoryListMain/categoryListMain.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'categoryListMainService', function (stateService, categoryListMainService) {
//            const vm = this;

//            vm.model = {
//                itemsListMainCategories: []
//            };

//            async function loadMainCategories() {
//                vm.model.itemsListMainCategories = await categoryListMainService.listMainCategories();
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'categorylinkadd':
//                        go({ category_keyno_belongto: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = function () {
//                loadMainCategories();
//            }
//        }]
//    });
//})();
